import React, { memo, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import OrderSummary from '../../../common/OrderSummary';
import pubSubInstance from '../../../../shared/utils/pubSub';
import useCurrentAmountAndCreditBalance from '../../../../shared/utils/currentAmountAndCreditBalance/useCurrentAmountAndCreditBalance';
import { amountSum } from '../../../../shared/utils/commonUtils';
import { usePennyRounding } from '../../../../shared/utils/customizedHooks';

const OrderSummaryContainer = ({ trackingCallback, className }) => {
  const {
    locale, orderSummaryTitle, widgetNameSpace,
  } = useSelector(state => state.propsData);
  const {
    entities: {
      orderInfo,
      orderInfo: { totalAmount, currencyCode },
    },
  } = useSelector(state => state.mainStateData);
  const {
    amountDue, currentPaymentOptionType, entities: { paymentOptionData },
  } = useSelector(state => state.paymentOptions);

  const {
    currentActivePaymentMethod,
    entities: {
      paymentMethods: {
        cashInfo: {
          pennyRounding,
        } = {},
      } = {},
    },
  } = useSelector(state => state.paymentMethods);

  const {
    yourPayment, currentCreditBalance, useCreditBalance, paymentProcessingFee,
    futurePaymentProcessingFeeAmount,
  } = useCurrentAmountAndCreditBalance();
  const handleSubmit = useCallback(() => {
    pubSubInstance.dispatch(`${widgetNameSpace}-submit-order`);
  }, [ widgetNameSpace ]);

  const totalPPF = useMemo(() => amountSum(paymentProcessingFee, futurePaymentProcessingFeeAmount),
    [ paymentProcessingFee, futurePaymentProcessingFeeAmount ]);

  const ppfTotalAmount = useMemo(() => amountSum(totalPPF, totalAmount),
    [ totalAmount, totalPPF ]);

  const deposit = useMemo(() => (((currentPaymentOptionType === 'PAY_DEPOSIT_WITH_PAYMENT_PLAN' || currentPaymentOptionType === 'PAY_LATER') && (totalAmount !== amountDue)) ? amountDue : undefined),
    [ amountDue, totalAmount, currentPaymentOptionType ]);

  const {
    pennyRoundingAmount,
    grandTotal,
  } = usePennyRounding([ yourPayment, currentActivePaymentMethod, pennyRounding, currencyCode ]);

  if (isEmpty(orderInfo) || isEmpty(paymentOptionData)) {
    return null;
  }
  return (
    <OrderSummary {...orderInfo }
      totalAmount={ppfTotalAmount}
      widgetNameSpace={widgetNameSpace}
      totalPPF={totalPPF}
      currentPPF={paymentProcessingFee}
      deposit={deposit}
      className={className}
      currentAmountDue={yourPayment}
      useCreditBalance={useCreditBalance}
      currentCreditBalance={currentCreditBalance}
      paymentMethodType={currentActivePaymentMethod}
      locale={locale}
      orderSummaryTitle={orderSummaryTitle}
      onSubmit={handleSubmit}
      pennyRoundingAmount={pennyRoundingAmount}
      grandTotal={grandTotal}
      trackingCallback={trackingCallback}/>
  );
};

export default memo(OrderSummaryContainer);
